/* eslint-disable camelcase */
import React from 'react';

import PropTypes from 'prop-types';

import getBuilderStateContentVariantData from '~/builder/utils/getBuilderStateContentVariantData';
import { CIOBrowseProvider } from '~/gridv2/context/CIOBrowseProvider';
import { GRID_TYPES, GridInputProvider } from '~/gridv2/hooks/useGridInputs';
import GridViewRenderer from '~/gridv2/views/GridViewRenderer';

const BuilderConstructorGridV2 = ({
  assetContainer,
  builderState,
  categoryIdOverride,
  categorySelection,
  collectionIdOverride,
  collectionSelection,
  discoveryGuide: discoveryGuideProp,
  facet,
  facetOption,
  filterType,
  gridGender,
  gridHeader,
  gridStyleGuide,
  productSource,
  sideNav,
  sortOptions,
}) => {
  // This is to prevent content shift between SSR and CSR hydration
  if (typeof window === 'undefined') {
    return null;
  }

  const pageData = getBuilderStateContentVariantData({
    builderStateContent: builderState?.content,
  });
  const gridSpotlights = pageData?.gridSpotlights?.value?.data;
  const discoveryGuide = discoveryGuideProp?.value?.data;

  return (
    <GridInputProvider
      value={{
        assetContainer,
        builderState,
        builderModel: builderState?.state?.modelName,
        discoveryGuide,
        categoryIdOverride,
        categorySelection,
        collectionIdOverride,
        collectionSelection,
        facet,
        facetOption,
        filterType,
        gridGender,
        gridHeader,
        gridStyleGuide, // @deprecated in favor of using `discoveryGuide`
        gridSpotlights,
        gridType: GRID_TYPES.BUILDER_CONSTRUCTOR_GRID,
        productSource,
        sideNav,
        sortOptions,
      }}
    >
      <CIOBrowseProvider>
        <GridViewRenderer />
      </CIOBrowseProvider>
    </GridInputProvider>
  );
};

BuilderConstructorGridV2.propTypes = {
  assetContainer: PropTypes.shape({
    gridAssetContainer: PropTypes.string,
    gridAssetContainerMobile: PropTypes.string,
  }),
  builderState: PropTypes.object,
  categoryIdOverride: PropTypes.string,
  categorySelection: PropTypes.shape({
    value: PropTypes.string,
  }),
  collectionIdOverride: PropTypes.string,
  collectionSelection: PropTypes.shape({
    value: PropTypes.string,
  }),
  discoveryGuide: PropTypes.shape({
    value: PropTypes.shape({
      data: PropTypes.object,
    }),
  }),
  facet: PropTypes.string,
  facetOption: PropTypes.string,
  filterType: PropTypes.string,
  gridGender: PropTypes.string,
  gridHeader: PropTypes.string,
  gridStyleGuide: PropTypes.shape({
    tagList: PropTypes.string,
    assetContainers: PropTypes.shape({
      desktop: PropTypes.string,
      mobile: PropTypes.string,
      marketingCard: PropTypes.string,
    }),
  }),
  productSource: PropTypes.string,
  sideNav: PropTypes.shape({
    shouldShowCategoryNav: PropTypes.bool,
  }),
  sortOptions: PropTypes.array,
};

export default BuilderConstructorGridV2;
